import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { apiUrl } from "../../config";

const initialState = {
  postId: 0,
  userId: "",
  tags: "",
  title: "",
  content: "",
  bannerImageUrl: "",
};

const PostsForm = ({ onSave, initialData, readOnly, loading, setLoading }) => {
  const [posts, setPosts] = useState(initialState);
  const [previewImage, setPreviewImage] = useState(null);


  useEffect(() => {
    return () => {
      if (previewImage && previewImage.startsWith("blob")) {
        URL.revokeObjectURL(previewImage);
      }
    };
  }, [previewImage]);

  useEffect(() => {
    if (initialData) {
      setPosts(initialData);
      if (initialData.bannerImageUrl) {
        if (typeof initialData.bannerImageUrl === "string") {
          // Existing image URL
          setPreviewImage(apiUrl + "/" + initialData.bannerImageUrl);
        } else if (initialData.bannerImageUrl instanceof File) {
          // New file selected
          const url = URL.createObjectURL(initialData.bannerImageUrl);
          setPreviewImage(url);
        }
      } else {
        setPreviewImage(null);
      }
    } else {
      const authUser = JSON.parse(localStorage.getItem("VVRHCS"));;
      console.log("auth", authUser);

      setPosts({
        ...initialState,
        userId: authUser.userId || "",
      });
      setPreviewImage(null);
    }
  }, [initialData]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPosts((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPosts((prev) => ({ ...prev, bannerImageUrl: file }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    onSave(posts);
    setTimeout(() => {
      setLoading(false);
    }, 2000)
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Control
        type="hidden"
        name="userId"
        value={posts.userId}
      />
      <Row className="mb-3">
        {/* <Col md={4}>
          <Form.Group controlId="userId">
            <Form.Label>
              User Id <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="hidden"
              name="userId"
              value={posts.userId}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col> */}
        <Col md={4}>
          <Form.Group controlId="tags">
            <Form.Label>
              Tags <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="tags"
              value={posts.tags}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="title">
            <Form.Label>
              Title <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={posts.title}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <Form.Group controlId="content">
            <Form.Label>
              content <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              as="textarea"
              rows={5}
              name="content"
              value={posts.content}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <Form.Group controlId="image">
            <Form.Label>Image</Form.Label>
            <Form.Control
              type="file"
              onChange={handleFileChange}
              disabled={readOnly}
            />
            {previewImage && (
              <div className="mt-2">
                <img
                  src={previewImage}
                  alt="Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    marginTop: "10px",
                  }}
                />
              </div>
            )}
          </Form.Group>
        </Col>
      </Row>
      {!readOnly && (
        <Row>
          <Col>
            <div className="form-buttons">
              <Button type="submit" className="me-2"
                disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Saving...
                  </>
                ) : (
                  "Save"
                )}
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setPosts(initialState);
                  setPreviewImage(null);
                }}
              >
                Clear
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </Form>
  );
};

export default PostsForm;
